/**
 * Muted hyphen placeholder for table cells / fields that have no value to display.
 */
export const EmptyValue = () => <span className="text-muted-foreground">-</span>;
